import React from 'react'
import classNames from 'classnames'
import { PopupProps } from '@yk-component/yk-popup'
import Popup from './popup'
import './bubble.less'

export declare interface BubbleProps extends PopupProps {
  className?: string;
  popupClassName?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  size?: 'small' | 'middle' | 'large';
  arrow?: boolean;
}

const Bubble = (props: BubbleProps) => {
  const {
    className,
    popupClassName,
    style,
    children,
    size = 'small',
    arrow = false,
    ...bubbleProps
  } = props

  return (
    <Popup
      position={size === 'small' ? 'top' : 'bottom'}
      animation="Scale"
      className={popupClassName}
      {...bubbleProps}
    >
      <div
        onClick={(ev) => ev.stopPropagation()}
        className={classNames(
          `kBubble--${size}`,
          { 'kBubble--arrow': arrow },
          className
        )}
        style={style}
      >
        {children}
        {arrow && <span className="arrow" />}
      </div>
    </Popup>
  )
}

export default Bubble
